<template>
</template>

<script>
export default {
  name: 'FacilityDetail',
  components: {
  },
  data() {
    return {
      isPricePlanModalVisible : false,
    }
  },
  computed: {
  },
  methods: {
    toggleTab: function(target, e) {
      $('.active').each((_, el) => {
        el.classList.remove('active');
      })

      $('.show').each((_, el) => {
        el.classList.remove('show');
      })

      e.target.classList.add("active");
      $(target).addClass("active");
      $(target).addClass("show");
      if (e.target.parentElement){
        e.target.parentElement.classList.add("active");
      };
      if (e.target.parentElement){
        e.target.parentElement.classList.add("show");
      };
    },
    showPricePlanModal() {
      this.isPricePlanModalVisible = true
    },
    hidePricePlanModal(){
      this.isPricePlanModalVisible = false
    }
  },
}
</script>

 v-on:click="toggleTab('#detailAbstract', $event)"
